import { TFunction } from "i18next";
import * as yup from "yup";

export const helpdeskModalValidationSchema = (errorsT: TFunction) =>
  yup.object({
    message: yup.string().required(errorsT("required"))
  });
